export const CONTAINER_ID = 'entri-full-page-container';
const DEFAULT_CSS_TEXT = 'position:fixed;inset:0;z-index:6000;background:#fff;';
export function mountEntriContainer(options) {
  if (document.getElementById(CONTAINER_ID)) {
    return;
  }
  const el = document.createElement('div');
  el.id = CONTAINER_ID;
  el.style.cssText = (options == null ? void 0 : options.cssText) ?? DEFAULT_CSS_TEXT;
  ((options == null ? void 0 : options.parent) ?? document.body).appendChild(el);
}
export function unmountEntriContainer() {
  var _document$getElementB;
  (_document$getElementB = document.getElementById(CONTAINER_ID)) == null || _document$getElementB.remove();
}
//# sourceMappingURL=entriFullPageContainer.js.map